import { render, staticRenderFns } from "./WDemandFiles.vue?vue&type=template&id=699c19c8&scoped=true&"
import script from "./WDemandFiles.vue?vue&type=script&lang=js&"
export * from "./WDemandFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699c19c8",
  null
  
)

export default component.exports